<template>
  <div>
    <top />
    <div class="top-padding">
      <banner v-if="this.$route.path != '/home'" />
      <innav v-if="this.$route.path != '/home'" />
      <router-view />
    </div>
    <bottom />
  </div>
</template>

<script>
import top from "./compones/header.vue";
import bottom from "./compones/footer.vue";
import banner from "./compones/inbanner.vue";
import innav from "./compones/innav.vue";
export default {
  components: { top, bottom, banner, innav },
};
</script>

<style lang="scss" scoped>
.top-padding {
  padding-top: 100px;
  @media only screen and (max-width: 1200px) {
    padding-top: 62px;
  }
}
</style>
